import { apiUrl } from "../components/LoginSignup";

const postBookingEmail = async (endpoint, booking) => {
  const userSession = JSON.parse(localStorage.getItem("userSession") || "{}");

  if (!userSession?.token) {
    throw new Error("Please log in again to send the email.");
  }

  if (!booking?.email) {
    throw new Error("Client email is not available for this booking.");
  }

  const response = await fetch(`${apiUrl}/booking/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: userSession.token,
    },
    body: JSON.stringify(booking),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || "Failed to send email. Please try again.");
  }

  return data;
};

export const sendAgreementEmail = (booking) =>
  postBookingEmail("agreement/email", booking);

export const sendInvoiceEmail = (booking) =>
  postBookingEmail("invoice/email", booking);
